import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import upperFirst from 'lodash/upperFirst';
import { Headline1, Headline2, Headline3, Headline4, Headline5, Body17, Body16, Body15, Body14, Caption12, Caption11, Caption10, Caption9, CaptionCaps9 } from './Typography.styles';

var mapColor = function mapColor(color) {
  return "color".concat(capitalize(color));
};

var mapWeight = function mapWeight(weight) {
  return "weight".concat(upperFirst(weight));
};

var selectVariant = function selectVariant(variant) {
  switch (variant) {
    case 'h1':
      return Headline1;

    case 'h2':
      return Headline2;

    case 'h3':
      return Headline3;

    case 'h4':
      return Headline4;

    case 'h5':
      return Headline5;

    case 'body17':
      return Body17;

    case 'body16':
      return Body16;

    case 'body15':
      return Body15;

    case 'body14':
      return Body14;

    case 'caption12':
      return Caption12;

    case 'caption11':
      return Caption11;

    case 'caption10':
      return Caption10;

    case 'caption9':
      return Caption9;

    case 'captionCaps9':
      return CaptionCaps9;

    default:
      return Body16;
  }
};

var Typography = React.forwardRef(function (_a, ref) {
  var children = _a.children,
      variant = _a.variant,
      color = _a.color,
      weight = _a.weight,
      tabularNumbers = _a.tabularNumbers,
      className = _a.className,
      other = __rest(_a, ["children", "variant", "color", "weight", "tabularNumbers", "className"]);

  var ElementStyled = selectVariant(variant);
  var combinedClassName = classnames(className, color && mapColor(color), weight && mapWeight(weight), {
    tabularNumbers: tabularNumbers
  });
  return _jsx(ElementStyled, __assign({
    className: combinedClassName,
    ref: ref
  }, other, {
    children: children
  }));
});
export default Typography;